import type { IInjector, IInjectorModule } from '@paperbits/common/injection';

import { SERPHTMLElement } from './serp-runtime';
import { SearchClient } from '../../../../search/client/searchClient';

export class SERPRuntimeModule implements IInjectorModule {
    public register(injector: IInjector): void {
        customElements.define('serp-runtime', SERPHTMLElement);
        injector.bindSingletonFactory('searchClient', () => new SearchClient());
    }
}